export const QRCODE_STORE_PRE_KEY = 'QRCODE_LIST_';